import { visitRecordConstants } from "@constants";

const initalState = {
  query: {
    loading: false,
    constructionUuid: null,
    condition: {},
    total: 0,
    statistics: {},
    items: [],
    fail: null
  }
};

export const visitRecords = (state = initalState, action) => {
  switch (action.type) {
    case visitRecordConstants.GET_ALL_REQUEST:
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: true
        }
      };
    case visitRecordConstants.GET_ALL_SUCCESS:
      const { total, statistics, items, condition, constructionUuid } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          constructionUuid,
          condition,
          total,
          statistics,
          items
        }
      };
    case visitRecordConstants.GET_ALL_FAILURE:
      const { error } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          fail: error
        }
      };
    case visitRecordConstants.RESET_ALL_SUCCESS:
      return initalState;
    default:
      return state;
  }
};
